// Control UI module implements string coerce behavior.
export {
  normalizeLowercaseStringOrEmpty,
  normalizeOptionalLowercaseString,
  normalizeOptionalString,
} from "@altto/normalization-core/string-coerce";
export {
  normalizeStringEntries,
  sortUniqueStrings,
  uniqueStrings,
} from "@altto/normalization-core/string-normalization";
